import { Tag } from '@lifebit-ai/lds'
import React from 'react'

import { FALLBACK_FIELD_VALUE } from './useViewFormModal'
import { type FieldComponentProps, type TagsFormField } from './fieldTypes'
import { renderFieldHelpText } from './HelpText'
import * as styles from './ViewFormModal.styles'

export const TagsField = ({ field }: FieldComponentProps<TagsFormField>) => {
  const values = field.values ?? []

  return (
    <styles.GroupField>
      <styles.FieldLabel>{field.label}</styles.FieldLabel>
      {renderFieldHelpText(field.helpText)}
      <styles.Tags>
        {values.length ? (
          values.map(value => <Tag key={`${field.id}-${value}`}>{value}</Tag>)
        ) : (
          <styles.EmptyText>{FALLBACK_FIELD_VALUE}</styles.EmptyText>
        )}
      </styles.Tags>
    </styles.GroupField>
  )
}
